<template>
  <div class="relative" v-bind="$attrs">
    <div ref="map" class="custom-google-map" :class="mapElementClass"></div>
    <div style="display: none" class="overflow-hidden">
      <div ref="popup" class="max-w-[19rem] -m-8">
        <offer-item v-if="selectedMarker"
          :name="selectedMarker.title"
          :img="selectedMarker.images[0]"
          :price="selectedMarker.price"
          :location="selectedMarker.location"
          :area="selectedMarker.area"
          :rooms="selectedMarker.rooms"
          :link="selectedMarker.href"
        ></offer-item>
      </div>
    </div>
    <transition name="fade-in">
      <div
        class="
          absolute
          right-4
          bottom-4
          pointer-events-none
          bg-white
          rounded overflow-hidden
        "
        v-if="showZoom"
      >
        <button
          class="
            w-8
            aspect-squar
            bg-white
            pointer-events-auto
            text-blue
            grid
            place-items-center
            border-b border-blue
            text-[1.5rem]
          "
          aria-label="Zoom in"
          @click="zoom(true)"
        >
          +
        </button>
        <button
          class="
            w-8
            aspect-square
            bg-white
            pointer-events-auto
            text-blue
            grid
            place-items-center
            text-[1.5rem]
          "
          aria-label="Zoom out"
          @click="zoom(false)"
        >
          -
        </button>
      </div>
    </transition>
  </div>
</template>

<script>
import offerItem from './offers/offer-item.vue'
import GoogleMap from '../../lib/google-map'

export default {
  name: 'MapWithPopup',
  components: {
    offerItem,
  },
  data() {
    return {
      selectedMarker: null,
      googleMap: null,
    }
  },
  mounted() {
    this.googleMap = new GoogleMap(this.$refs.map, {
      markersDir: this.markersDir,
      onMarkerClick: (markerData) => {
        this.selectedMarker = markerData
      },
      infowindowContent: this.$refs.popup,
      useCircles: false,
      mapOptions: this.mapOptions,
      noClusterer: this.noClusterer,
      swissCoordinates: this.swissCoordinates,
      onBoundsChange: (bounds) => this.$emit('boundschange', bounds),
      initialBounds: this.initialBounds,
      spiderify: this.spiderify,
    })
    this.googleMap.setMarkers(this.markers)
    if (!this.disableAutoFit) {
      this.googleMap.fitToMarkers()
    }
  },
  props: {
    markers: Array,
    mapElementClass: String,
    markersDir: String,
    cardComponent: String,
    showZoom: Boolean,
    mapOptions: Object,
    noClusterer: Boolean,
    swissCoordinates: Boolean,
    initialBounds: {
      type: Object,
      default: null,
    },
    disableAutoFit: {
      type: Boolean,
      default: false,
    },
    spiderify: Boolean,
  },
  watch: {
    markers(newMarkers) {
      this.googleMap.setMarkers(newMarkers)
      if (!this.disableAutoFit) {
        this.googleMap.fitToMarkers()
      }
    },
  },
  methods: {
    zoom(increase) {
      const zoom = this.googleMap.map.getZoom()
      this.googleMap.map.setZoom(increase ? zoom + 1 : zoom - 1)
    },
  }
}
</script>